/* models/pdf.js */ function _(require, module, exports, __esModule, __esExport) {
    __esModule();
    var _a;
    const markup_1 = require("@bokehjs/models/widgets/markup");
    const layout_1 = require("ea218d1c3c") /* ./layout */;
    const html_1 = require("15e8e695c0") /* ./html */;
    class PDFView extends layout_1.PanelMarkupView {
        connect_signals() {
            super.connect_signals();
            const p = this.model.properties;
            const { text, width, height, embed, start_page } = p;
            this.on_change([text, width, height, embed, start_page], () => {
                this.update();
            });
        }
        render() {
            super.render();
            this.update();
        }
        update() {
            if (this.model.embed) {
                const blob = this.convert_base64_to_blob();
                const url = URL.createObjectURL(blob);
                const w = this.model.width || "100%";
                const h = this.model.height || "100%";
                this.container.innerHTML = `<embed src="${url}#page=${this.model.start_page}" type="application/pdf" width="${w}" height="${h}"></embed>`;
            }
            else {
                const html = (0, html_1.htmlDecode)(this.model.text);
                this.container.innerHTML = html || "";
            }
        }
        convert_base64_to_blob() {
            const byteCharacters = atob(this.model.text);
            const sliceSize = 512;
            var byteArrays = [];
            for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                const slice = byteCharacters.slice(offset, offset + sliceSize);
                const byteNumbers = new Uint8Array(slice.length);
                for (let i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }
                byteArrays.push(byteNumbers);
            }
            return new Blob(byteArrays, { type: "application/pdf" });
        }
    }
    exports.PDFView = PDFView;
    PDFView.__name__ = "PDFView";
    class PDF extends markup_1.Markup {
        constructor(attrs) {
            super(attrs);
        }
    }
    exports.PDF = PDF;
    _a = PDF;
    PDF.__name__ = "PDF";
    PDF.__module__ = "panel.models.markup";
    (() => {
        _a.prototype.default_view = PDFView;
        _a.define(({ Number, Boolean }) => ({
            embed: [Boolean, true],
            start_page: [Number, 1],
        }));
    })();
}
